




















import { Component, Prop, Watch } from 'vue-property-decorator';
import CanBeSizedMixin from '../../mixins/CanBeSizedMixin.vue';
import { ShopDetailsModel, ShopInfoModel } from '../../models/ShopDetails';

@Component({})
export default class ShopProductDetails extends CanBeSizedMixin {
  /* tslint:disable */
  @Prop() private offers!: ShopDetailsModel[];
  /* tslint:enable */

  public getDistanceString(info: ShopInfoModel) {
    if (info.distance < 5) {
      return '';
    }
    return ` (${info.distance} km)`;
  }
  public getShopUrl(offer: ShopInfoModel) {
    return `/Haendler/${offer.urlFriendlyName}/${offer.id}`;
  }
}
